<template>
  <div>
    <el-dialog
        :visible.sync="loginDialog"
        :show-close="true"
        :close-on-click-modal="false"
        class="login-container"
        width="480px"
        @close="handleDialogClose">

      <el-tabs v-model="activeName" @tab-click="handleClick" stretch class="login-tabs">
        <!-- 登录面板 -->
        <el-tab-pane label="登录" name="login">
          <particle-effect-button color="LightPink" :duration="800" type="circle" draw-style="fill">
            <el-form
                ref="loginForm"
                :model="loginForm"
                :rules="loginRules"
                class="login-form"
                auto-complete="on"
                label-position="left">

              <div class="title-container">
                <h3 class="title">欢迎登录</h3>
                <p class="subtitle">请输入您的账号信息</p>
              </div>

              <el-form-item prop="username">
                <div class="input-wrapper">
                  <i class="el-icon-user input-icon"></i>
                  <el-input
                      ref="username"
                      v-model="loginForm.username"
                      placeholder="请输入登录账号"
                      name="username"
                      type="text"
                      tabindex="1"
                      auto-complete="on"
                      clearable>
                  </el-input>
                </div>
              </el-form-item>

              <el-form-item prop="password">
                <div class="input-wrapper">
                  <i class="el-icon-lock input-icon"></i>
                  <el-input
                      :key="passwordType"
                      ref="password"
                      v-model="loginForm.password"
                      :type="passwordType"
                      placeholder="请输入密码"
                      name="password"
                      tabindex="2"
                      auto-complete="on"
                      @keyup.enter.native="handleLogin">
                  </el-input>
                  <i
                      :class="['toggle-pwd', passwordType === 'password' ? 'el-icon-view' : 'el-icon-view active']"
                      @click="showPwd">
                  </i>
                </div>
              </el-form-item>

              <el-button
                  :loading="loading"
                  type="primary"
                  class="submit-btn"
                  @click.native.prevent="handleLogin">
                {{ loading ? '登录中...' : '登录' }}
              </el-button>

              <div class="forgot-password">
                <el-checkbox v-model="rememberPwd">
                  <span class="remember-text">记住密码</span>
                </el-checkbox>
                <div class="forgot-link">
                  <el-link type="primary" :underline="false" @click="handleForgetPwdClick">
                    忘记密码？
                  </el-link>
                </div>
              </div>
            </el-form>
          </particle-effect-button>
        </el-tab-pane>

        <!-- 注册面板 -->
        <el-tab-pane label="注册" name="register">
          <particle-effect-button color="LightPink" :duration="800" type="circle" draw-style="fill">
            <el-form
                ref="registerForm"
                :model="registerForm"
                :rules="registerRules"
                class="login-form"
                auto-complete="on"
                label-position="left">

              <div class="title-container">
                <h3 class="title">注册账号</h3>
                <p class="subtitle">注册成功后将自动登录</p>
              </div>

              <el-form-item prop="username">
                <div class="input-wrapper">
                  <i class="el-icon-mobile-phone input-icon"></i>
                  <el-input
                      v-model="registerForm.username"
                      placeholder="请输入手机号"
                      maxlength="11"
                      name="username"
                      type="text"
                      tabindex="1"
                      auto-complete="on"
                      clearable>
                  </el-input>
                </div>
              </el-form-item>

              <el-form-item prop="password">
                <div class="input-wrapper">
                  <i class="el-icon-lock input-icon"></i>
                  <el-input
                      :key="'reg-' + passwordType"
                      v-model="registerForm.password"
                      minlength="4"
                      maxlength="20"
                      :type="passwordType"
                      placeholder="请输入密码(4-20位)"
                      name="password"
                      tabindex="2"
                      auto-complete="on"
                      @keyup.enter.native="handleRegister">
                  </el-input>
                  <i
                      :class="['toggle-pwd', passwordType === 'password' ? 'el-icon-view' : 'el-icon-view active']"
                      @click="showPwd">
                  </i>
                </div>
              </el-form-item>

              <div class="captcha-wrapper">
                <el-input
                    ref="codeInput"
                    v-model="codeValue"
                    placeholder="请输入验证码"
                    type="text"
                    class="captcha-input"
                    @keyup.enter.native="handleRegister">
                </el-input>
                <div class="captcha-code" @click="refreshCode">
                  <inentify :fresh="flag" @makedCode="getMakedCode"></inentify>
                </div>
              </div>

              <el-button
                  :loading="registerLoading"
                  type="primary"
                  class="submit-btn register-btn"
                  @click.native.prevent="handleRegister">
                {{ registerLoading ? '处理中...' : '注册' }}
              </el-button>
            </el-form>
          </particle-effect-button>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import ParticleEffectButton from 'vue-particle-effect-button'
import inentify from './inentify.vue'
import {login, register} from '@/api/index.js'

export default {
  name: 'LoginDialog',

  components: {
    ParticleEffectButton,
    inentify
  },

  props: {
    loginDialogShow: {
      type: Boolean,
      default: false
    }
  },

  data() {
    // 密码验证规则
    const validatePassword = (rule, value, callback) => {
      if (!value || value.length < 4) {
        callback(new Error('密码长度不能少于4位'))
      } else {
        callback()
      }
    }

    // 手机号验证规则
    const checkPhone = (rule, value, callback) => {
      const phoneReg = /^1[3-9][0-9]{9}$/
      if (!value) {
        return callback(new Error('手机号码不能为空'))
      }
      if (!Number.isInteger(+value)) {
        callback(new Error('请输入正确的手机号'))
      } else if (!phoneReg.test(value)) {
        callback(new Error('手机号码格式不正确'))
      } else {
        callback()
      }
    }

    return {
      // 验证码相关
      codeValue: '',
      flag: true,
      code: '',

      // 弹窗控制
      loginDialog: false,

      // 表单数据
      loginForm: {
        username: '',
        password: ''
      },
      registerForm: {
        username: '',
        password: ''
      },

      // 验证规则
      loginRules: {
        username: [
          {required: true, message: '请输入登录账号', trigger: 'blur'}
        ],
        password: [
          {required: true, trigger: 'blur', validator: validatePassword}
        ]
      },
      registerRules: {
        username: [
          {required: true, trigger: 'blur', validator: checkPhone}
        ],
        password: [
          {required: true, trigger: 'blur', validator: validatePassword}
        ]
      },

      // 状态控制
      loading: false,
      registerLoading: false,
      passwordType: 'password',
      activeName: 'login',
      rememberPwd: false
    }
  },

  watch: {
    loginDialogShow: {
      immediate: true,
      handler(val) {
        this.loginDialog = val
      }
    },
    loginDialog(val) {
      if (!val) {
        this.$emit('closeDialog')
        this.resetForms()
      }
    }
  },

  mounted() {
    this.refreshCode()
  },

  methods: {
    /**
     * 刷新验证码
     */
    refreshCode() {
      this.flag = !this.flag
    },

    /**
     * 获取生成的验证码
     */
    getMakedCode(code) {
      this.code = code
    },

    /**
     * Tab 切换处理
     */
    handleClick() {
      this.refreshCode()
      this.resetForms()
    },

    /**
     * 切换密码显示/隐藏
     */
    showPwd() {
      this.passwordType = this.passwordType === 'password' ? '' : 'password'
      this.$nextTick(() => {
        this.$refs.password?.focus()
      })
    },

    /**
     * 找回密码点击
     */
    handleForgetPwdClick() {
      this.$alert('请联系管理员重置账号密码，QQ联系：630691351', '找回密码', {
        confirmButtonText: '我知道了',
        type: 'info'
      })
    },

    /**
     * 重置表单
     */
    resetForms() {
      this.$refs.loginForm?.resetFields()
      this.$refs.registerForm?.resetFields()
      this.codeValue = ''
      this.passwordType = 'password'
    },

    /**
     * 关闭弹窗处理
     */
    handleDialogClose() {
      this.resetForms()
    },

    /**
     * 注册处理
     */
    async handleRegister() {
      // 验证码校验
      if (this.codeValue.toLowerCase() !== this.code.toLowerCase()) {
        this.$message.error('请输入正确的验证码')
        this.refreshCode()
        return
      }

      try {
        // 表单验证
        await this.$refs.registerForm.validate()
      } catch {
        return
      }

      this.registerLoading = true

      try {
        const param = {
          loginAccount: this.registerForm.username,
          password: this.registerForm.password
        }

        const res = await register(param)

        if (res.code === '0000') {
          this.$message.success('注册成功，正在自动登录...')

          // 保存注册信息用于自动登录
          const loginAccount = this.registerForm.username
          const loginPassword = this.registerForm.password

          // 清空注册表单
          this.registerForm.username = ''
          this.registerForm.password = ''
          this.codeValue = ''

          // 自动调用登录
          await this.doLogin(loginAccount, loginPassword)
        } else {
          this.$message.error(res.message || '注册失败')
          this.refreshCode()
        }
      } catch (error) {
        console.error('注册失败:', error)
        this.$message.error('注册失败，请稍后重试')
        this.refreshCode()
      } finally {
        this.registerLoading = false
      }
    },

    /**
     * 登录处理
     */
    async handleLogin() {
      try {
        await this.$refs.loginForm.validate()
      } catch {
        return
      }

      await this.doLogin(this.loginForm.username, this.loginForm.password)
    },

    /**
     * 执行登录操作（供注册成功后自动调用）
     * @param {string} account - 登录账号
     * @param {string} password - 登录密码
     */
    async doLogin(account, password) {
      this.loading = true

      try {
        const param = {
          loginAccount: account,
          password: password
        }

        const res = await login(param)

        if (res.code === '0000') {
          // 存储登录信息
          const {token, sessionId, userVipType, userId, sex, agentFlag, teacherFlag} = res.data

          localStorage.setItem('token', token)
          localStorage.setItem('sessionId', sessionId)
          localStorage.setItem('userVipType', userVipType)
          localStorage.setItem('userId', userId)
          localStorage.setItem('username', account)
          localStorage.setItem('sex', sex)
          localStorage.setItem('agentFlag', agentFlag)
          localStorage.setItem('teacherFlag', teacherFlag)

          this.$message.success('登录成功!')
          this.loginDialog = false
          this.$emit('loginSuccess')
        } else {
          this.$message.error(res.message || '登录失败')
        }
      } catch (error) {
        console.error('登录失败:', error)
        this.$message.error('登录失败，请稍后重试')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>


<style lang="scss" scoped>
// 变量定义
$primary-color: #409EFF;
$text-color: #303133;
$text-secondary: #909399;
$border-color: #DCDFE6;
$bg-color: #F5F7FA;
$input-height: 48px;
$border-radius: 8px;

// 弹窗样式
::v-deep .el-dialog {
  border-radius: 12px;
  overflow: hidden;

  .el-dialog__header {
    padding: 8px 16px;
    border-bottom: none;

    .el-dialog__headerbtn {
      top: 12px;
      right: 12px;
      font-size: 18px;
    }
  }

  .el-dialog__body {
    padding: 0 32px 32px;
  }
}

// Tabs 样式
.login-tabs {
  ::v-deep .el-tabs__header {
    margin-bottom: 16px;
  }

  ::v-deep .el-tabs__item {
    font-size: 16px;
    font-weight: 500;
    height: 44px;
    line-height: 44px;

    &.is-active {
      color: $primary-color;
    }
  }

  ::v-deep .el-tabs__active-bar {
    height: 3px;
    border-radius: 2px;
  }
}

// 表单样式
.login-form {
  width: 334px;
  margin: 0 auto;

  .title-container {
    text-align: center;
    margin-bottom: 32px;

    .title {
      font-size: 24px;
      font-weight: 600;
      color: $text-color;
      margin: 0 0 8px 0;
    }

    .subtitle {
      font-size: 14px;
      color: $text-secondary;
      margin: 0;
    }
  }
}

// 表单项样式
::v-deep .el-form-item {
  margin-bottom: 20px;

  .el-form-item__error {
    padding-top: 4px;
  }
}

// 输入框包装器
.input-wrapper {
  display: flex;
  align-items: center;
  background: $bg-color;
  border: 1px solid $border-color;
  border-radius: $border-radius;
  transition: all 0.3s ease;
  overflow: hidden;

  &:hover {
    border-color: lighten($primary-color, 20%);
  }

  &:focus-within {
    border-color: $primary-color;
    box-shadow: 0 0 0 2px rgba($primary-color, 0.1);
  }

  .input-icon {
    width: 48px;
    font-size: 18px;
    color: $text-secondary;
    text-align: center;
    flex-shrink: 0;
  }

  .toggle-pwd {
    width: 48px;
    font-size: 18px;
    color: $text-secondary;
    text-align: center;
    cursor: pointer;
    flex-shrink: 0;
    transition: color 0.3s;

    &:hover,
    &.active {
      color: $primary-color;
    }
  }

  ::v-deep .el-input {
    flex: 1;

    .el-input__inner {
      height: $input-height;
      line-height: $input-height;
      border: none;
      background: transparent;
      padding: 0 12px 0 0;
      font-size: 14px;
      color: $text-color;

      &::placeholder {
        color: #C0C4CC;
      }
    }

    .el-input__suffix {
      right: 12px;
    }
  }
}

// 验证码区域
.captcha-wrapper {
  display: flex;
  gap: 12px;
  margin-bottom: 20px;

  .captcha-input {
    flex: 1;

    ::v-deep .el-input__inner {
      height: $input-height;
      border-radius: $border-radius;
      background: $bg-color;
      border-color: $border-color;

      &:hover {
        border-color: lighten($primary-color, 20%);
      }

      &:focus {
        border-color: $primary-color;
      }
    }
  }

  .captcha-code {
    width: 120px;
    height: $input-height;
    border-radius: $border-radius;
    overflow: hidden;
    cursor: pointer;
    flex-shrink: 0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    transition: box-shadow 0.3s ease;

    &:hover {
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
    }
  }
}

// 提交按钮
.submit-btn {
  width: 100%;
  height: $input-height;
  font-size: 16px;
  font-weight: 500;
  border-radius: $border-radius;
  margin-top: 8px;

  &.register-btn {
    margin-top: 0;
  }
}

// 忘记密码区域
.forgot-password {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;

  .remember-text {
    font-size: 14px;
    color: $text-secondary;
  }

  .forgot-link {
    .el-link {
      font-size: 14px;
    }
  }
}

// 响应式适配
@media (max-width: 480px) {
  ::v-deep .el-dialog {
    width: 90% !important;
    margin: 0 auto;

    .el-dialog__body {
      padding: 20px;
    }
  }

  .captcha-wrapper {
    flex-direction: column;

    .captcha-code {
      width: 100%;
    }
  }
}
</style>
